export const preferences = {
    'languages.go': {
        type: 'boolean',
        default: false,
        description: 'When enabled, go language connected',
    },
};
